import * as antdEnUSLanguage from "antd/locale/en_US";
import * as antdZhCNSLanguage from "antd/locale/zh_CN";
import * as antdTwCNSLanguage from "antd/locale/zh_TW";
import * as antdJPCNSLanguage from "antd/locale/ja_JP";
import * as antdKRCNSLanguage from "antd/locale/ko_KR";
import * as antdMYCNSLanguage from "antd/locale/ms_MY";
import * as antdTHCNSLanguage from "antd/locale/th_TH";
import * as antdESCNSLanguage from "antd/locale/es_ES";
import * as antdINCNSLanguage from "antd/locale/hi_IN";
import * as antdEGCNSLanguage from "antd/locale/ar_EG";
import * as antdDECNSLanguage from "antd/locale/de_DE";
import * as antdFRCNSLanguage from "antd/locale/fr_FR";
import * as antdTRCNSLanguage from "antd/locale/tr_TR";
import * as antdVNCNSLanguage from "antd/locale/vi_VN";

import { find } from "lodash";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";

import { zhCN } from "./zh-CN";
import { enUS } from "./en-US";
import { zhTW } from "./zh-TW";
import { jap } from "./jap";
import { kr } from "./kr";
import { my } from "./my";
import { th } from "./th";
import { es } from "./es";
import { ind } from "./ind";
import { ar } from "./ar";
import { de } from "./de";
import { la } from "./la";
import { turk } from "./turk";
import { vn } from "./vn";

if (!localStorage.getItem("language")) {
  localStorage.setItem("language", "zh-CN");
}

const languageSetting = () => {
  return localStorage.getItem("language") || navigator.language || "zh-CN";
};

const CURRENT_LANGUAGE = languageSetting();

export const languages = [
  {
    id: "en-US",
    locale: "en",
    name: "English",
    antd: antdEnUSLanguage.default,
    config: enUS
  },
  {
    id: "zh-CN",
    locale: "zh-cn",
    name: "简体中文",
    antd: antdZhCNSLanguage.default,
    config: zhCN
  },
  {
    id: "zh-TW",
    locale: "zh-tw",
    name: "繁体中文",
    antd: antdTwCNSLanguage.default,
    config: zhTW
  },
  {
    id: "jap",
    locale: "jap",
    name: "日语",
    antd: antdJPCNSLanguage.default,
    config: jap
  },
  {
    id: "kr",
    locale: "kr",
    name: "韩语",
    antd: antdKRCNSLanguage.default,
    config: kr
  },
  {
    id: "my",
    locale: "my",
    name: "马来语",
    antd: antdMYCNSLanguage.default,
    config: my
  },
  {
    id: "th",
    locale: "th",
    name: "泰语",
    antd: antdTHCNSLanguage.default,
    config: th
  },
  {
    id: "es",
    locale: "es",
    name: "西班牙语",
    antd: antdESCNSLanguage.default,
    config: es
  },
  {
    id: "ind",
    locale: "ind",
    name: "印度语",
    antd: antdINCNSLanguage.default,
    config: ind
  },
  {
    id: "ar",
    locale: "ar",
    name: "阿拉伯语",
    antd: antdEGCNSLanguage.default,
    config: ar
  },
  {
    id: "de",
    locale: "de",
    name: "德语",
    antd: antdDECNSLanguage.default,
    config: de
  },
  {
    id: "la",
    locale: "la",
    name: "法语",
    antd: antdFRCNSLanguage.default,
    config: la
  },
  {
    id: "turk",
    locale: "turk",
    name: "土耳其语",
    antd: antdTRCNSLanguage.default,
    config: turk
  },
  {
    id: "vn",
    locale: "vn",
    name: "越南语",
    antd: antdVNCNSLanguage.default,
    config: vn
  },
];

const config = find(languages, ["id", CURRENT_LANGUAGE]);
dayjs.locale("zh-cn");

export const language = config;

export const langCommon = language?.config.common;
export const langPage = language?.config.page;
export const langTableColumns = language?.config.tableColumns;
